import type { PanelEntry } from "./api";
import { API_BASE } from "./base";
import { workspaceMemory } from "./workspaces";

/**
 * Which of an Agent's overview workspaces this browser opened last, so that an Agent with several opens
 * on the one the owner was using. It is a convenience of this browser, kept in its own storage and
 * never read as a fact about the Agent: with nothing stored, or storage that refuses, the owner is
 * asked which one.
 */
const storageKey = (scope: string) => `pa:last-workspace:${scope}`;

/** `scope` is the Agent's address prefix as `lib/drafts` writes it: `/agents/<id>`, or `/` for a lone console. */
export function readLastWorkspace(scope: string = API_BASE || "/"): string | null {
  try { return localStorage.getItem(storageKey(scope)); } catch { return null; }
}

export function rememberWorkspace(panel: PanelEntry, scope: string = API_BASE || "/"): void {
  try { localStorage.setItem(storageKey(scope), workspaceMemory(panel)); } catch { /* the owner is asked next time */ }
}
